import { getLoginUserInfo,loginUser } from '@/service/api';
import { IUserState } from "@/typings/factory";
import { Module } from 'vuex';
import { IGlobalState } from '..';
import * as Types from '../action-types';
import { getCookie } from '@/utils/common';

const state: IUserState = {
    id: getCookie('userid'),
    token: getCookie('token'),
    mobile: '',
    email: '',
    enterpriseFullName: '',
    enterpriseShortName: '',
    unifiedSocialCreditCode: '',
    businessLicense: '',
    state: 0,
    examineState: 0,
    provinceId: '',
    provinceName: '',
    cityId: '',
    cityName: '',
    createTime: '',
    districtId: '',
    districtName: ''   
};

const user: Module<IUserState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_USER_LOGIN](state, payload: IUserState) {
            state.id = payload.id,
            state.token = payload.token,
            state.mobile = payload.mobile,
            state.email = payload.email,
            state.enterpriseFullName = payload.enterpriseFullName,
            state.enterpriseShortName = payload.enterpriseShortName,
            state.unifiedSocialCreditCode = payload.unifiedSocialCreditCode,
            state.businessLicense = payload.businessLicense,
            state.state = payload.state,
            state.examineState = payload.examineState,
            state.provinceId = payload.provinceId,
            state.provinceName = payload.provinceName,
            state.cityId = payload.cityId,
            state.cityName = payload.cityName,
            state.createTime = payload.createTime,
            state.districtId = payload.districtId,
            state.districtName = payload.districtName   
        },
        [Types.SET_USER_INFO](state, payload: IUserState) {
            state.id = payload.id,
            state.mobile = payload.mobile,
            state.email = payload.email,
            state.enterpriseFullName = payload.enterpriseFullName,
            state.enterpriseShortName = payload.enterpriseShortName,
            state.unifiedSocialCreditCode = payload.unifiedSocialCreditCode,
            state.businessLicense = payload.businessLicense,
            state.state = payload.state,
            state.examineState = payload.examineState,
            state.provinceId = payload.provinceId,
            state.provinceName = payload.provinceName,
            state.cityId = payload.cityId,
            state.cityName = payload.cityName,
            state.createTime = payload.createTime,
            state.districtId = payload.districtId,
            state.districtName = payload.districtName   
        }
    },
    actions: {
        async [Types.SET_USER_LOGIN]({ commit }, param) {
            return new Promise((resolve, reject) => {
                loginUser(param)
                    .then(function (response: any) {
                        if (response && response.code > 0) {
                            if (response.code === 1) {
                                let user: IUserState = response.data;
                                commit(Types.SET_USER_LOGIN, user);
                                document.cookie = "token=" + user.token + ";path=/";
                                document.cookie = "userid=" + user.id + ";path=/";
                                resolve(response);
                            }
                        } else {
                            reject(response.msg);
                        }
                    })
                    .catch(function (error: any){
                        reject(error);
                    });
            });
        },
        async [Types.SET_USER_INFO]({ commit }, param) {
            return new Promise((resolve, reject) => {
                getLoginUserInfo(param)
                    .then(function (response: any) {
                        if (response && response.code > 0) {
                            if (response.code === 1) {
                                let user: IUserState = response.data;
                                commit(Types.SET_USER_INFO, user);
                                resolve(response);
                            }
                        } else {
                            reject(response.msg);
                        }
                    })
                    .catch(function (error: any){
                        reject(error);
                    });
            });
        }
    }
};
export default user;